import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function Produto() {
    const location = useLocation();
    const navigate = useNavigate();
    const { produtoInfo } = location.state || { produtoInfo: undefined };
    // const [produto, setProduto] = useState(location.state?.produto || {});
    const [isLoading, setIsLoading] = useState(false);
    const loggedIn = sessionStorage.getItem('loggedIn');
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    const uuid = customFormatDate.replace('-', '').replace(' ', '').replace(':', '').replace(':', '').replace('/', '').replace('/', '');

    useEffect(() => {
        if (!loggedIn) {
            navigate('/login');
        }
    }, [loggedIn, navigate]);

    const [ produto, setProduto ] = useState({
        IdProduto: 0,
        proDescricao: '',
        proTipo: '',
        proTamanho: '',
        proCor: '',
        proModelo: '',
        proValorCusto: 0.00,
        proMargemLucro: 0.00,
        proValorVenda: 0.00,
        proEstoque: 0,
        proAceitaPedido: 0,
        proDependeEstoque: 0,
        proLinkDeCompra: '',
        proStatus: 1,
        proObservacoes: '',
        proCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : 'Usuário Desconecido',
        proCriadoEm: customFormatDate,
        proAlteradoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : 'Usuário Desconecido',
        proAlteradoEm: customFormatDate,
        proCodigoGUID: uuid + '-'+ Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    });

    useEffect(() => {
        if (produtoInfo) {
            setProduto({
                ...produtoInfo,
                IdProduto: produtoInfo.IdProduto || 0,
                proDescricao: produtoInfo.proDescricao || '',
                proTipo: produtoInfo.proTipo || '',
                proTamanho: produtoInfo.proTamanho || '',
                proCor: produtoInfo.proCor || '',
                proModelo: produtoInfo.proModelo || '',
                proValorCusto: produtoInfo.proValorCusto || 0.00,
                proMargemLucro: produtoInfo.proMargemLucro || 0.00,
                proValorVenda: produtoInfo.proValorVenda || 0.00,
                proEstoque: produtoInfo.proEstoque || 0,
                proAceitaPedido: produtoInfo.proAceitaPedido || 0,
                proDependeEstoque: produtoInfo.proDependeEstoque || 0,
                proLinkDeCompra: produtoInfo.proLinkDeCompra || '',
                proStatus: produtoInfo.proStatus || 1,
                proObservacoes: produtoInfo.proObservacoes || '',
                proAlteradoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : 'Usuário Desconecido',
                proAlteradoEm: customFormatDate,
                proCodigoGUID: produtoInfo.proCodigoGUID || uuid + '-'+ Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
            });
            //setProduto(produtoInfo);
        }
    }, [produtoInfo]);

    function handleInputChange(event) {
        console.log('Input changed:', event.target.name, event.target.value, event.target.checked);

        if(event.target.name === 'proAceitaPedido' || event.target.name === 'proDependeEstoque' || event.target.name === 'proStatus') {
            setProduto({
                ...produto,
                [event.target.name]: event.target.checked ? 1 : 0
            });
        } else if (event.target.name !== 'proValorCusto' && event.target.name !== 'proMargemLucro' && event.target.name !== 'proValorVenda') {
            setProduto({
                ...produto,
                [event.target.name]: event.target.value
            });
        } else if (event.target.name === 'proValorCusto' || event.target.name === 'proMargemLucro' || event.target.name === 'proValorVenda') {
            const value = event.target.value.replace(',', '.');
            // se o target name for proMargemLucro e tiver valor em produto.proValorCusto, calcular o proValorVenda
            if (event.target.name === 'proMargemLucro' && produto.proValorCusto) {
                if (event.target.value === '') {
                    setProduto({
                        ...produto,
                        proMargemLucro: 0,
                        proValorVenda: produto.proValorCusto
                    });
                    return;
                }
                const valorCusto = parseFloat(produto.proValorCusto);
                const margemLucro = parseFloat(value);
                const valorVenda = valorCusto + (valorCusto * (margemLucro / 100));
                //se valorVenda for NaN, setar proValorVenda com o mesmo valor de produto.proValorCusto
                if (isNaN(valorVenda)) {
                    valorVenda = valorCusto;
                }
                setProduto({
                    ...produto,
                    proMargemLucro: value,
                    proValorVenda: valorVenda.toFixed(2)
                });
            } else {
                setProduto({
                    ...produto,
                    [event.target.name]: value
                });
            }
            //console.log('Numeric input changed:', event.target.name, value);
            // setProduto({
            //     ...produto,
            //     [event.target.name]: value
            // });
        }
    };

    //console.log('Produto state:', produto);

    function handleFecharForm(){
        window.history.back();
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            let urlAPI = "";
            let method = "";
            if (produto.IdProduto) {
                // Update existing product
                //await axios.put(`/api/produtos/${produto.IdProduto}`, produto);
                urlAPI = process.env.REACT_APP_API_URL + '/routes.php?metodo=atualizarProduto';
                method = "update";
            } else {
                // Create new product
                urlAPI = process.env.REACT_APP_API_URL + '/routes.php?metodo=novoProduto';
                method = "create";
            }
            axios
            .post(urlAPI, produto, {
                headers: {
                    'X-Access-Token': tokenAPI,
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            })
            .then((response) => {
                console.log(`Product ${method}d successfully:`, response.data);
            })
            .catch((error) => {
                console.error(`Error ${method}ing product:`, error);
            });


            navigate('/produtos');
        } catch (error) {
            console.error('Error saving product:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
            setTimeout(() => {
                const elemento = document.getElementById('btnVoltar');
                elemento.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 500);
        }, []);

    return (
        <>
            <main>
                <div>
                    {/* fechar */}
                    <div className='d-flex w100 mt1 flex-column text-align-left'>
                        <div className='text-align-left w80'>
                            <button id="btnVoltar"
                                className="buttonModalPadraoLaranja fs11"
                                onClick={handleFecharForm}
                                style={{ cursor: 'pointer' }}
                                >
                                    Voltar
                            </button>
                        </div>
                    </div>
                    {/* form */}
                    <form onSubmit={handleSubmit}>
                        <div className='headerMain'>
                            <label className='labelTitulo' >{produto.IdProduto ? 'EDITAR PRODUTO' : 'NOVO PRODUTO'}</label>
                        </div>
                        <div className="d-flex w100 flex-column tdAlignLeft pb4">
                            {/* Descrição do Produto */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label htmlFor="proDescricao">Descrição:</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input
                                            type="text"
                                            className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                            id="proDescricao"
                                            name="proDescricao"
                                            value={produto.proDescricao || ''}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* Tipo - Tamanho - Cor - Modelo */}
                            <div className="d-flex flex-row divForm">
                                <div className="d-flex flex-row  w100">
                                    <div className="w100">
                                        <div className='text-align-left divForm fs16'>
                                            <label htmlFor="proTipo">Tipo:</label>
                                        </div>
                                        <div className='text-align-left divForm w100 fs12'>
                                            <input
                                                type="text"
                                                className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                                id="proTipo"
                                                name="proTipo"
                                                value={produto.proTipo || ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="w33">
                                        <div className='text-align-left divForm fs16'>
                                            <label htmlFor="proTamanho">Tamanho:</label>
                                        </div>
                                        <div className='text-align-left divForm w100 fs12'>
                                            <input
                                                type="text"
                                                className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                                id="proTamanho"
                                                name="proTamanho"
                                                value={produto.proTamanho || ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="w100">
                                        <div className='text-align-left divForm fs16'>
                                            <label htmlFor="proCor">Cor:</label>
                                        </div>
                                        <div className='text-align-left divForm w100 fs12'>
                                            <input
                                                type="text"
                                                className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                                id="proCor"
                                                name="proCor"
                                                value={produto.proCor || ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="w100">
                                        <div className='text-align-left divForm fs16'>
                                            <label htmlFor="proModelo">Modelo:</label>
                                        </div>
                                        <div className='text-align-left divForm w100 fs12'>
                                            <input
                                                type="text"
                                                className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                                id="proModelo"
                                                name="proModelo"
                                                value={produto.proModelo || ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Qtde Estoque - Valor Custo - Valor Margem - Valor Venda */}
                            <div className="d-flex flex-row divForm">
                                <div className="d-flex flex-row  w100">
                                    <div className="w33">
                                        <div className='text-align-left divForm fs16'>
                                            <label htmlFor="proEstoque">Qtde.Estoque:</label>
                                        </div>
                                        <div className='text-align-left divForm w100 fs12'>
                                            <input
                                                type="text"
                                                className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                                id="proEstoque"
                                                name="proEstoque" 
                                                format="number"
                                                value={produto.proEstoque || ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="w100">
                                        <div className='text-align-left divForm fs16'>
                                            <label htmlFor="proValorCusto">Custo:</label>
                                        </div>
                                        <div className='text-align-left divForm w100 fs12'>
                                            <input
                                                type="text"
                                                className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                                id="proValorCusto"
                                                name="proValorCusto"
                                                value={produto.proValorCusto || ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="w100">
                                        <div className='text-align-left divForm fs16'>
                                            <label htmlFor="proMargemLucro">(%)Margem:</label>
                                        </div>
                                        <div className='text-align-left divForm w100 fs12'>
                                            <input
                                                type="text"
                                                className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                                id="proMargemLucro"
                                                name="proMargemLucro"
                                                value={produto.proMargemLucro || ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="w100">
                                        <div className='text-align-left divForm fs16'>
                                            <label htmlFor="proValorVenda">Venda:</label>
                                        </div>
                                        <div className='text-align-left divForm w100 fs12'>
                                            <input
                                                type="text"
                                                className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                                id="proValorVenda"
                                                name="proValorVenda"
                                                value={produto.proValorVenda || ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Aceita Pedido - Depende de Estoque - Status do produto */}
                            <div className="d-flex flex-row divForm">
                                <div className="d-flex flex-row  w100">
                                    <div style={{ whiteSpace: 'nowrap' }} className='divForm fs16 w100'>
                                        <label htmlFor="proAceitaPedido">Aceita Pedido:</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input
                                            type="checkbox"
                                            id="proAceitaPedido"
                                            style={{ transform: 'scale(2.1)', margin: '15px' }} 
                                            name="proAceitaPedido"
                                            checked={produto.proAceitaPedido || false}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex flex-row  w100">
                                    <div style={{ whiteSpace: 'nowrap' }} className='text-align-left divForm fs16 w100'>
                                        <label htmlFor="proDependeEstoque">Depende Estoque:</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs16'>
                                        <input
                                            type="checkbox"
                                            id="proDependeEstoque" 
                                            style={{ transform: 'scale(2.1)', margin: '15px' }} 
                                            name="proDependeEstoque"
                                            checked={produto.proDependeEstoque || false}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="d-flex flex-row  w100">
                                    <div style={{ whiteSpace: 'nowrap' }} className='text-align-right divForm fs16 w100'>
                                        <label htmlFor="proStatus">Ativo:</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input
                                            type="checkbox"
                                            id="proStatus"
                                            style={{ transform: 'scale(2.1)', margin: '15px' }} 
                                            name="proStatus"
                                            checked={produto.proStatus || false}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Observações */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label htmlFor="proObservacoes">Observações:</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input
                                            type="text"
                                            className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                            id="proObservacoes"
                                            name="proObservacoes"
                                            value={produto.proObservacoes || ''}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Link de Compra */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label htmlFor="proLinkDeCompra">Link de Compra:</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input
                                            type="text"
                                            className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                            id="proLinkDeCompra"
                                            name="proLinkDeCompra"
                                            value={produto.proLinkDeCompra || ''}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='text-align-left mt2 mb4 divForm fs14'>
                                {parseInt(sessionStorage.pesAdmin) === 1 ? (
                                <button 
                                    className='buttonModalPadrao pt1 pb1 w100 fs14'
                                    type="submit" disabled={isLoading}>
                                        {isLoading ? 'Salvando...' : 'Salvar'}
                                </button> ) : ('') } 
                            </div>
                        </div>

                    </form>
                </div>
            </main>
        </>
    );
}